import { Tooltip as o } from "./Tooltip.js";
import { TooltipContent as t } from "./TooltipContent.js";
import { tooltipContentClassName as T } from "./TooltipContent.js";
import { TooltipTrigger as r } from "./TooltipTrigger.js";
const m = Object.assign(o, {
  Content: t,
  Trigger: r
});
export {
  m as Tooltip,
  T as tooltipContentClassName
};
